import React from 'react';

const SearchBar = ({ searchText, onChange, onSubmit, onFocus }) => {
    return (
        <div id="search_whole">
            <form onSubmit={onSubmit}>
                <div className="form-groupp input-group">
                    <input
                        id="search_input_box"
                        className="form-control border-primary border p-0 px-2"
                        type="search"
                        placeholder="Search for products, brands or advice"
                        name="search_text"
                        autoComplete="off"
                        value={searchText}
                        onChange={onChange}
                        onFocus={onFocus}
                    />
                    <span className="input-group-text btn rounded-0 px-2" id="basic-addon2" onClick={onSubmit}>
                        <i className="icon-search" />
                    </span>
                </div>
            </form>
        </div>
    );
};

export default SearchBar;
